interface Contract {
  environment: string;
  featureFlag: string[];
  isProduction: boolean;
  baseUrl: string;
}

export const Environment: Contract = {
  environment: process.env.REACT_APP_ENV,
  featureFlag: (process.env.REACT_APP_FEATURE_FLAG || '').split(';'),
  isProduction: (process.env.REACT_APP_ENV || '').toLowerCase() === 'production',
  baseUrl: process.env.REACT_APP_BASE_URL,
};
